import * as React from 'react';
import PropTypes from 'prop-types';
import {
    makeStyles,
    TextField,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    disabledReadonlyInput: {
        color: theme.palette.text.primary,
    },
}));

const AsyncTextField = ({
    label, value, onChange, delay, readOnly, shrink, ...props
}) => {
    const classes = useStyles();
    const [inputValue, setInputValue] = React.useState(null);
    const updateAsyncTimer = React.useRef();

    const handleChange = (event) => {
        const updatedValue = event.target.value;
        setInputValue(updatedValue);

        if (updateAsyncTimer.current) clearTimeout(updateAsyncTimer.current);

        updateAsyncTimer.current = setTimeout(() => {
            onChange(updatedValue);
        }, delay);
    };

    return (
        <TextField
            fullWidth
            value={inputValue !== null ? inputValue : value}
            onChange={handleChange}
            label={label}
            disabled={readOnly}
            InputProps={{ classes: { disabled: readOnly ? classes.disabledReadonlyInput : null } }}
            InputLabelProps={{ shrink }}
            {...props}
        />
    )
}

AsyncTextField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    delay: PropTypes.number,
    readOnly: PropTypes.bool,
    shrink: PropTypes.bool,
};

AsyncTextField.defaultProps = {
    delay: 300,
    readOnly: false,
    shrink: false,
};

export default AsyncTextField;
